import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

function Icon ({ icon, className, srOnly, inline, onClick, ...iconProps }) {
    const iconClasses = cn(`otrl otrl-${icon}`, className, { 'otrl-inline': inline });

    if (srOnly) {
        return (
            <i onClick={onClick} className={iconClasses} {...iconProps}>
                <span className="sr-only">{srOnly}</span>
            </i>
        );
    }
    return <i onClick={onClick} className={iconClasses} aria-hidden="true" {...iconProps} />;
}

Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    className: PropTypes.string,
    srOnly: PropTypes.string,
    inline: PropTypes.bool,
    onClick: PropTypes.func,
};

Icon.defaultProps = {
    className: '',
    srOnly: '',
};

export default Icon;
